import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { ShsTimeInput } from 'src/components/common';

interface TimeSlotProps {
    index: number;
    getSource: (source: string) => string;
    // called when either `from` or `to` for this slot changes
    onSlotChange?: () => void;
}

const TimeSlot: React.FC<TimeSlotProps> = ({ index, getSource, onSlotChange }) => {
    const { control } = useFormContext();

    // watch the two fields for this slot and call the parent handler when they change
    const values = useWatch({ control, name: [getSource('from'), getSource('to')] }) as any[] | undefined;

    useEffect(() => {
        // only call when values actually change (including initial mount)
        if (onSlotChange) {
            onSlotChange();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values?.[0], values?.[1]]);

    return (
        <Grid container alignItems="center" spacing={1}>
            <Grid item alignItems="center">
                <ShsTimeInput source={getSource('from')} label="з" />
            </Grid>
            <Grid item>
                <ShsTimeInput source={getSource('to')} label="до" />
            </Grid>
        </Grid>
    );
};

export default TimeSlot;
